// extracted by mini-css-extract-plugin
export default {"styledDiv":"network_styledDiv__460DF"};